import type React from 'react';
import styles from './index.module.css';

export type LessonTitleProps = {
  chapterName: string;
  lessonName: string;
};

export const LessonTitle: React.FC<LessonTitleProps> = ({
  chapterName,
  lessonName,
}) => {
  return (
    <h2 className={styles.lessonTitle}>
      <p className={styles.chapterName}>{chapterName}</p>
      <p className={styles.lessonName}>{lessonName}</p>
    </h2>
  );
};
